import { createPortal } from 'react-dom';
import { GtxReactPage } from './GtxApp';
import { Header } from 'gtx-react/components';

/**
 * Iterate over the pages and create a portal for each page
 * The portal will be used to render the page content and the header
 * if the header is defined and not hidden
 */
export const createPagePortals = (pages: GtxReactPage[]) => {
    return pages.map((pageItem) => {
        const ContainerComponent = pageItem.container;

        const hideHeader = pageItem.header === false;
        const backUrl = pageItem.header && pageItem.header?.backUrl;
        const hideOnMobile = pageItem.header && pageItem.header?.hideOnMobile;

        const handleBack = () => {
            if (!backUrl) {
                return;
            }

            if (document?.referrer?.indexOf(backUrl) > -1) {
                window.location.href = document.referrer;
            } else {
                window.location.href = backUrl;
            }
        };

        const contentElement = document.getElementById('content');
        return {
            path: pageItem.path,
            goBack: handleBack,
            portal: ({ queryString, headerActions }) => {
                const HeaderComponent = headerActions || null;
                const customTitle = pageItem.header
                    ? pageItem.header?.customTitle
                    : undefined;

                return contentElement ? (
                    createPortal(
                        <>
                            {!hideOnMobile && !hideHeader && (
                                <Header
                                    title={
                                        customTitle ??
                                        document?.querySelector<HTMLElement>(
                                            '#site-section-title'
                                        )?.innerText
                                    }
                                    actions={
                                        HeaderComponent && <HeaderComponent />
                                    }
                                    hasBackBtn={!!backUrl}
                                    onBack={handleBack}
                                />
                            )}
                            <ContainerComponent queryString={queryString} />
                        </>,
                        contentElement
                    )
                ) : (
                    <></>
                );
            },
        };
    });
};
